import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { InboxService } from '../../../../../../../../services/inbox/inbox.service';
import { DocumentPendingStaffApproval, StaffApprovalAction } from '../../../../../../../../models/inbox';
import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../../../utils';
import { AccountService } from '../../../../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-review-document-pending-staff-approval-modal',
  templateUrl: './review-document-pending-staff-approval-modal.component.html',
  styleUrls: ['./review-document-pending-staff-approval-modal.component.css']
})
export class ReviewDocumentPendingStaffApprovalModalComponent implements OnInit {

  @Input() documentId: string;
  @Input() showHideOption: boolean;
  @Input() savedCallback: () => undefined;

  public document: DocumentPendingStaffApproval;

  public selectedAction: StaffApprovalAction = null;

  public loadingDocument = true;
  public loadingSubmit = false;
  public documentNotFound = false;
  public errorMessage = '';
  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public StaffApprovalAction = StaffApprovalAction;
  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService,
    private accountService: AccountService,
    private inboxService: InboxService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }
    this.loadDocument();
  }

  /**
   * Whether a valid input has been selected. Used to determine whether the
   * save button is clickable.
   */
  public validInputSelected(): boolean {
    return [
      StaffApprovalAction.approve,
      StaffApprovalAction.deny,
      StaffApprovalAction.hide
    ].includes(this.selectedAction);
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    if (!this.validInputSelected()) {
      this.errorMessage = 'Please choose a valid option.';
      this.loadingSubmit = false;
      return;
    }

    this.inboxService
      .manageDocumentPendingStaffApproval(
        this.document.document_id,
        this.selectedAction
      )
      .then(() => {
        this.inboxService.loadInboxCounts(true).then();
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to review this document.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  private loadDocument() {
    this.loadingDocument = true;

    this.inboxService
      .getDocumentPendingStaffApprovalInboxItem(this.documentId)
      .then(document => {
        this.document = document;
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.documentNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingDocument = false; });
  }

}
